<template>
  <div>
    <slot></slot>
    {{ helpText }}
    <a
      v-for="(mergeField, i) in mergeFields"
      :key="`merge-field-${i}`"
      href
      @click.prevent="insert(mergeField)"
    >
      {{ format(mergeField) }},
    </a>
  </div>
</template>

<script>
import $ from 'jQuery';

export default {
  props: {
    mergeFields: {
      type: Array,
      default: () => []
    },
    helpText: {
      type: String,
      default: 'Available merge fields:'
    },
    targetElements: {
      type: Array,
      default: () => ['textarea', 'input']
    }
  },
  data() {
    return {
      lastMarkdownEditorInFocus: null
    };
  },
  computed: {
    inputElements() {
      let inputElements = [];

      this.targetElements.forEach(elementType => {
        const elements = this.$el.getElementsByTagName(elementType);
        if (elements) {
          inputElements = [...inputElements, ...elements];
        }
      });

      return inputElements;
    }
  },
  mounted() {
    // Listen to the 'mdeFocus' event and track the markdown editor that
    // was last in focus, so that a merge field can be inserted into it later
    if (this.inputElements.length) {
      $(this.inputElements).on('mdeFocus', (e, editor, line, ch) => {
        this.lastMarkdownEditorInFocus = { editor, line, ch };
      });
    }
  },
  beforeDestroy() {
    // Detach the event handler
    if (this.inputElements.length) {
      $(this.inputElements).off('mdeFocus');
    }
  },
  methods: {
    insert(mergeField) {
      if (!this.lastMarkdownEditorInFocus) {
        return;
      }

      const editor = this.lastMarkdownEditorInFocus.editor;
      const line = this.lastMarkdownEditorInFocus.line;
      const ch = this.lastMarkdownEditorInFocus.ch;

      editor.setCursor({ line, ch });
      editor.getDoc().replaceRange(this.format(mergeField), editor.getCursor());
      editor.focus();
    },
    format(mergeField) {
      return '{' + mergeField + '}';
    }
  }
};
</script>
